<template>
  <div>
    <form
      :action="returnUrl"
      class="paymentWidgets"
      data-brands="VISA MASTER AMEX"
    />
    <ErrorSnackbar v-model="showError" />
  </div>
</template>

<script>
  import { CREATE_NEW_CHECKOUT_ID_MUTATION } from '../../constants/graphql/payments';
  import ErrorSnackbar from '../common/ErrorSnackbar';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';

  export default {
    name: 'PaymentForm',
    components: {
      ErrorSnackbar,
    },
    mixins: [formHelperMixin],
    props: {
      tokenizeOnly: {
        type: Boolean,
        default: false,
      },
      paymentPlan: {
        type: String,
        required: true,
      },
      voucherCode: {
        type: String,
        default: null,
      },
    },
    computed: {
      returnUrl() {
        const path =
          this.paymentPlan === 'ONCE_OFF'
            ? 'basic-payment'
            : 'annual-subscription';
        return window.location.origin + '/' + path;
      },
    },
    created() {
      this.createCheckoutId();
    },
    methods: {
      createCheckoutId() {
        let ckeditor = document.createElement('script');
        this.$apollo
          .mutate({
            mutation: CREATE_NEW_CHECKOUT_ID_MUTATION,
            variables: {
              testatorId: this.testatorId,
              paymentPlan: this.paymentPlan,
              tokenizeOnly: this.tokenizeOnly,
              voucherCode: this.voucherCode,
            },
          })
          .then(({ data: { initialiseNewPayment } }) => {
            this.scriptHasLoaded = false;
            ckeditor.setAttribute(
              'src',
              process.env.VUE_APP_PEACH_PAYMENTS_BASE_URL +
                '/v1/paymentWidgets.js?checkoutId=' +
                initialiseNewPayment
            );
            document.head.appendChild(ckeditor);
            this.$emit('payment-form-loaded');
          })
          .catch(error => {
            this.displayError();
            throw error;
          });
      },
    },
  };
</script>
